export default __webpack_public_path__ + "static/presse-fest-ruhpolding-2024-preview-975ffd37f76877e5d2d918b77eb76382.jpg";